<template>
  <div id="organizationProfileListContainer" class="updatable bs3-padding-top7">
    <fieldset id="organizationProfileList" class="table-dynamic bs3-row-reset">
        <legend v-if="pDisplayHeader" class="panel-section">
          <i class="fa-light fa-sitemap" aria-hidden="true"></i>
          {{pDictionary['dictionary.organization.plural']}} <span v-show="hasOrganizations" class="badge bs3-margin-left5">{{organizationCount}}</span>
        </legend>
    </fieldset>
    <organization-profile
      v-for="organizationRef in organizationRefList"
      :key="organizationRef.id"
      :p-currencies="pCurrencies"
      :p-language="pLanguage"
      :p-dictionary="pDictionary"
      :p-urls="pUrls"
      :p-src="pSrc"
      :p-src-id="pSrcId"
      :p-organization-ref="organizationRef">
    </organization-profile>
  </div>
</template>

<script>
import OrganizationProfile from "@/components/organization/OrganizationProfile";

export default {
  name: "OrganizationProfileList",
  components: {OrganizationProfile},
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pSrc: String,
    pSrcId: String,
    pDisplayHeader: Boolean,
    pOrganizationIds: Array
  },
  data: function() {
    return {
      organizationRefList: []
    }
  },
  methods: {
    refreshOrganizationRefList: function() {
      let _component = this;

      if(!Array.isArray(this.pOrganizationIds) || !this.pOrganizationIds.length )
      {
        _component.organizationRefList = [];
      }
      else
      {
        $.ajax({
                 type: "POST",
                 url: '/mediaplan/app/endpoints/json-api/ref/organizations',
                 data: JSON.stringify({
                                        organizationIds: _component.pOrganizationIds
                                      }),
                 headers: {
                   'Accept': 'application/json',
                   'Content-Type': 'application/json'
                 }
               }).done(function (refList) {
          _component.organizationRefList = refList;
        });
      }
    }
  },
  computed: {
    hasOrganizations: function() {
      return this.organizationRefList.length > 0;
    },
    organizationCount: function() {
      return this.organizationRefList.length;
    }
  },
  watch: {
    pOrganizationIds: function() {
      this.refreshOrganizationRefList();
    }
  },
  mounted: function() {
    this.refreshOrganizationRefList();
  }
}
</script>

<style scoped>

</style>